import * as actionTypes from '../constants';

export const setUserInf = (data) => {
  return {
    type: actionTypes.USER_SET_INFO,
    payload: data,
  };
};
